<template>
  <div class="itw-input-container">
    <span class="caption font-weight-medium" v-if="label">
      {{ label }} <span class="error--text" v-if="required">*</span>
    </span>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="model"
          :prepend-inner-icon="prependInnerIcon"
          :append-icon="appendIcon"
          :placeholder="placeholder"
          :hide-details="hideDetails"
          :rules="rules"
          :disabled="disabled"
          :readonly="true"
          dense
          :class="color === 'white' ? 'custom-field-white' : 'custom-field'"
          solo
          flat
          filled
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu"
        v-model="model"
        :format="format"
        :min="min"
        :max="max"
        :allowed-hours="allowedHours"
        :allowed-minutes="allowedMinutes"
        :use-seconds="useSeconds"
        color="primary"
        full-width
        @click:minute="onMinuteClick"
        @click:second="onSecondClick"
      >
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="menu = false">Cancel</v-btn>
        <v-btn color="primary" depressed @click="menu = false">OK</v-btn>
      </v-time-picker>
    </v-menu>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  name: "ItwTimePicker",
  mixins: [hasModel],
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "Select time",
    },
    prependInnerIcon: {
      type: String,
      required: false,
      default: "schedule",
    },
    appendIcon: {
      type: String,
      required: false,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    format: {
      type: String,
      required: false,
      default: "24hr",
    },
    min: {
      type: String,
      required: false,
      default: undefined,
    },
    max: {
      type: String,
      required: false,
      default: undefined,
    },
    allowedHours: {
      type: [Array, Function],
      required: false,
      default: undefined,
    },
    allowedMinutes: {
      type: [Array, Function],
      required: false,
      default: undefined,
    },
    useSeconds: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "default",
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    onMinuteClick() {
      if (!this.useSeconds) {
        this.menu = false;
      }
    },
    onSecondClick() {
      this.menu = false;
    },
  },
};
</script>
